import fetch from '@/utils/fetch'

// 获取验证码图片
export function getImgCode () {
return fetch({
    url: '/pc/captcha/line-captcha/create',
    method: 'post'
})
}

// 发送短信验证码
export function messageAuthentication (data) {
return fetch({
    url: '/sms/message-send/ignore-send-code',
    method: 'post',
    data
})
}

// 查询手机号是否存在
export function queryMobile (data) {
return fetch({
    url: '/pc/user/validate-mobile/is-registered',
    method: 'post',
    data
})
}

// 用户注册
export function userRegister (data) {
return fetch({
    url: '/pc/user/register',
    method: 'post',
    data
})
}

// 用户登录 POST /pc/user/login
export function userLogin (data) {
return fetch({
    url: '/pc/user/login',
    method: 'post',
    data
})
}

// 忘记密码
export function forgotPassword (data) {
return fetch({
    url: '/pc/user/forgot-password',
    method: 'post',
    data
})
}

// 会员条款，免责声明
export function page(data) {
  return fetch({
    url: '/bms/protocol/page',
    method: 'POST',
    data
  });
}

// 短信验证码登录
export function messageCodeLogin(data) {
    return fetch({
      url: '/pc/user/mobile-login',
      method: 'POST',
      data
    });
  }